var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    className: "bottom_svg__thumbnail-align-down"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7FCCF7",
    d: "M29 26.364v2H9v-2h20zm-13-15a2 2 0 012 2v9a2 2 0 01-2 2h-3a2 2 0 01-2-2v-9a2 2 0 012-2h3z",
    className: "bottom_svg__illus-clr-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4EB7F5",
    d: "M27 22.364a2 2 0 01-2 2h-3a2 2 0 01-2-2v-6a2 2 0 012-2h3a2 2 0 012 2v6z",
    className: "bottom_svg__illus-clr-2"
  }))));
}

export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='38' height='38' viewBox='0 0 38 38'%3e %3cg fill='none' fill-rule='evenodd' class='thumbnail-align-down'%3e %3cpath fill='%237FCCF7' d='M29,26.3636364 L29,28.3636364 L9,28.3636364 L9,26.3636364 L29,26.3636364 Z M16,11.3636364 C17.104,11.3636364 18,12.2596364 18,13.3636364 L18,22.3636364 C18,23.4676364 17.104,24.3636364 16,24.3636364 L13,24.3636364 C11.896,24.3636364 11,23.4676364 11,22.3636364 L11,13.3636364 C11,12.2596364 11.896,11.3636364 13,11.3636364 L16,11.3636364 Z' class='illus-clr-1' /%3e %3cpath fill='%234EB7F5' d='M27,22.3636364 C27,23.4676364 26.104,24.3636364 25,24.3636364 L22,24.3636364 C20.896,24.3636364 20,23.4676364 20,22.3636364 L20,16.3636364 C20,15.2596364 20.896,14.3636364 22,14.3636364 L25,14.3636364 C26.104,14.3636364 27,15.2596364 27,16.3636364 L27,22.3636364 Z' class='illus-clr-2' /%3e %3c/g%3e %3c/svg%3e";
export { SvgBottom as ReactComponent };